import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './ClientInterface.css'; // Import the CSS file
import { useLocation } from 'react-router-dom';

const ClientInterface = () => {
  const [tableData, setTableData] = useState([
    /*{ name: '1000000013d94134', minJoystick: -0.1, maxJoystick: 0.1 },
    { name: '1000000013d94135', minJoystick: -0.06, maxJoystick: 0.06 },
    { name: '1000000013d94136', minJoystick: -0.08, maxJoystick: 0.08 },*/
  ]);

  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [minJoystick, setMinJoystick] = useState(0);
  const [maxJoystick, setMaxJoystick] = useState(0);

  const location = useLocation();
  const { username } = location.state || {};

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setMinJoystick(item.minJoystick);
    setMaxJoystick(item.maxJoystick);
    setShowModal(true);
  };

  const handleSaveChanges = () => {
    const updatedData = tableData.map((item) =>
      item.name === selectedItem.name
       ? {...item, minJoystick, maxJoystick }
        : item
    );
    setTableData(updatedData);
    setShowModal(false);
  };

  return (
    <>
      <div className="client-dashboard">
        <h2>Dashboard</h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Min Joystick</th>
              <th>Max Joystick</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item) => (
              <tr key={item.name} onClick={() => handleRowClick(item)}>
                <td>{item.name}</td>
                <td>{item.minJoystick}</td>
                <td>{item.maxJoystick}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Modal to update joystick values */}
        {selectedItem && (
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Update Joystick Values for {selectedItem.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div>
  <label>Tester Name : </label>
  <span>{selectedItem.name}</span>
  </div>
              <br/>
              <div>
                <label>Min Joystick:</label>
                <input
                  type="number"
                  value={minJoystick}
                  onChange={(e) => setMinJoystick(e.target.value)}
                />
              </div>
              <br/>
              <div>
                <label>Max Joystick:</label>
                <input
                  type="number"
                  value={maxJoystick}
                  onChange={(e) => setMaxJoystick(e.target.value)}
                />
              </div>
              <br/>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
              <Button variant="primary" onClick={handleSaveChanges}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ClientInterface;